import React from 'react';
import PropTypes from 'prop-types';

/**
 * On Web we need to include an actual input but hide it.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    checked,
    defaultChecked,
    disabled = false,
    id,
    isControlled,
    name,
    onChange = () => {},
    value
  } = _ref;
  const handleClick = event => {
    // Cancel the click dispatched via the label tag, since it's already wrapped
    // in <Pressable>
    event.preventDefault();
    event.stopPropagation();
  };
  return /*#__PURE__*/_jsx("input", {
    checked: isControlled ? checked : undefined,
    defaultChecked: isControlled ? undefined : defaultChecked,
    disabled: disabled,
    hidden: true,
    id: id,
    name: name,
    onChange: onChange,
    onClick: handleClick,
    ref: ref,
    type: "checkbox",
    value: value
  });
});
CheckboxInput.displayName = 'CheckboxInput';
CheckboxInput.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isControlled: PropTypes.bool.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};
export default CheckboxInput;